import React, { useState } from "react";
import PropTypes from "prop-types";
import * as FaIcons from "react-icons/fa";

const DashboardPdfExportButton = ({ label, loadingLabel, disabled, onExport }) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleClick = () => {
        setIsExporting(true);
        Promise.resolve(onExport())
            .catch(() => {})
            .finally(() => setIsExporting(false));
    };

    return (
        <button
            className="dashboard-export-button"
            type="button"
            disabled={disabled || isExporting}
            onClick={handleClick}
        >
            <FaIcons.FaFilePdf />
            <span>{isExporting ? loadingLabel : label}</span>
        </button>
    );
};

DashboardPdfExportButton.propTypes = {
    label: PropTypes.string.isRequired,
    loadingLabel: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onExport: PropTypes.func.isRequired
};

DashboardPdfExportButton.defaultProps = {
    disabled: false
};

export default DashboardPdfExportButton;
